<i18n src="../../lib/i18n/product/locales.json"></i18n>

<template>
    <Row>
        <navbar :transparent="isTransparent"></navbar>
        <div class="mogos_main">
            <div class="mogos_main_page">
                <div id="detail_slide_1" class="detail_slide_1" ref="mybox">
                    <div style="position:absolute;top:30%;left: 0;right:0;bottom:0;">
                        <i-col span="24">
                            <img src="../../assets/store/mogos_logo.png" class="mogos-logo">
                            <p class="details_banner_text">
                                {{$t('mogos_details_page_title')}}
                            </p>
                        </i-col>
                    </div>
                </div>
                <div class="layout-content" style="z-index: 1;">
                    <div class="Product-content mogos">
                        <div class="Product-content" style="background: #FFFFFF;padding:5% 0 5% 0;">
                            <Row style="padding:0 3% 0 3%">
                                <Col class="Product-left" :md="13" style="text-align: center;">
                                <img src="../../assets/store/mogos_card.png" class="mogos-logo">
                                </Col>
                                <Col class="Product-right" :md="11" style="text-align: left;">
                                <p class="Product-name">
                                    {{$t('mogos_details_page_product_title')}}
                                </p>
                                <p class="Product-price">
                                    <span style="text-decoration:line-through;color: red;"><span style="color: #0084ff;"> ${{goods_info.market_price}}</span></span>
                                    <span style="font-size: 28px;color: #0084ff">{{$t('free')}}</span>
                                </p>
                                <p class="Product-details">
                                   {{$t('mogos_details_page_product_content')}}
                                </p>
                                <ul>
                                    <li class="Product-details-li">{{$t('mogos_details_page_product_parameters1')}}</li>
                                    <li class="Product-details-li">{{$t('mogos_details_page_product_parameters2')}}</li>
                                    <li class="Product-details-li">{{$t('mogos_details_page_product_parameters3')}}</li>
                                </ul>
                                <div class="Free_collection" v-if="this.free == true">
                                    <router-link :to="{name:'Free'}" class="text-primary">
                                        <button>{{$t('mogos_free')}}</button>
                                    </router-link>
                                </div>
                                <buy v-else :id="parseInt($route.params.id)" :maxCount="parseInt(goods_info.store_count)"></buy>
                                </Col>
                            </Row>
                        </div>
                        <div class="Product-content speedy">
                            <div style="background:rgba(31,45,61,0.3);padding:20px 0 20px 0;">
                                <Row>
                                    <p class="Product-tips">
                                       {{$t('mogos_details_page_advantage1')}}
                                    </p>
                                </Row>
                                <Row style="" :gutter="30" class="details-card">
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                    <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                        <div style="text-align:center">
                                            <img src="../../assets/store/mogos_icon1.png">
                                            <span style="display: block;">{{$t('mogos_details_page_advantage1_content1')}}</span>
                                            <span style="display: block;">{{$t('mogos_details_page_advantage1_content1_1')}}<br>{{$t('mogos_details_page_advantage1_content1_2')}}</span>
                                        </div>
                                    </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon2.png">
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content2')}}</span>
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content2_1')}}<br>{{$t('mogos_details_page_advantage1_content2_2')}}</span>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon3.png">
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content3')}}</span>
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content3_1')}}<br>{{$t('mogos_details_page_advantage1_content3_2')}}</span>
                                            </div>
                                        </Card>
                                    </Col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon4.png">
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content4')}}</span>
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content4_1')}}<br>{{$t('mogos_details_page_advantage1_content4_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon5.png">
                                                <span style="display: block;"> {{$t('mogos_details_page_advantage1_content5')}}</span>
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content5_1')}}<br>{{$t('mogos_details_page_advantage1_content5_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                    <i-col :xs="24" :sm="12" :md="10" :lg="8" class="details_card_text">
                                        <Card style="background: rgba(31,45,61,0.40);border:none;color:#fff;">
                                            <div style="text-align:center">
                                                <img src="../../assets/store/mogos_icon6.png">
                                                <span style="display: block;"> {{$t('mogos_details_page_advantage1_content6')}}</span>
                                                <span style="display: block;">{{$t('mogos_details_page_advantage1_content6_1')}}<br>{{$t('mogos_details_page_advantage1_content6_2')}}</span>
                                            </div>
                                        </Card>
                                    </i-col>
                                </Row>
                            </div>
                        </div>

                        <div class="details_iapp_banner" style="max-width: 1300px;margin: 0 auto">
                            <i-col span="24">
                                <div class="layout-conten" id="mogos_phone">
                                    <div class="swiper-container">
                                        <i-col :xs="24" :sm="{span:12,offset:12}" :md="{span:12,offset:11}"
                                               :lg="{span:12,offset:11}" style="position: absolute;top: 0;">
                                            <p class="details_iapp_text details_iapp_text1">
                                                {{$t('mogos_details_page_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text details_iapp_text2">
                                                {{$t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                        <div class="swiper-wrapper">
                                            <div id="slider1" class="swiper-slide slider1" style="position: relative;">
                                            </div>
                                            <div id="slider2" class="swiper-slide slider2">
                                            </div>
                                            <div id="slider3" class="swiper-slide slider3">
                                            </div>
                                        </div>
                                        <!-- Add Pagination -->
                                        <div class="swiper-pagination">
                                        </div>
                                        <i-col span="12" offset="12">
                                            <p class="details_iapp_text"
                                               style="font-size: 30px;color: #1F2D3D;line-height: 78px;">
                                                {{$t('mogos_details_page_advantage2')}}
                                            </p>
                                            <p class="details_iapp_text"
                                               style="font-size: 22px;color: #5E6D82;line-height: 40px;">
                                                {{$t('mogos_details_page_advantage2_content')}}
                                            </p>
                                        </i-col>
                                    </div>
                                </div>
                                <div class="mobile-mogos-phone" style="display: none">
                                    <p class="details_iapp_text details_iapp_text1">
                                        {{$t('mogos_details_page_advantage2')}}
                                    </p>
                                    <p class="details_iapp_text details_iapp_text2">
                                        {{$t('mogos_details_page_advantage2_content')}}
                                    </p>
                                    <div class="mogos-step">
                                        <p class="Product-smname">1.{{$t('mogos_step_1')}}</p>
                                        <img src="../../assets/store/card_en.gif" alt="mogos-step-1" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/card_cn.gif" alt="mogos-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/card_cn.gif" alt="mogos-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                    <div class="mogos-step">
                                        <p class="Product-smname">2.{{$t('ichat_step_1')}}</p>
                                        <img src="../../assets/store/mogos_card_roaming_en.png" alt="mogos-step-2" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/mogos_card_roaming_cn.png" alt="mogos-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/mogos_card_roaming_tc.png" alt="mogos-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                    <div class="mogos-step">
                                        <p class="Product-smname">3.{{$t('ichat_step_2')}}</p>
                                        <img src="../../assets/store/mogos_card_confirm_en.png" alt="mogos-step-3" v-if="this.mogosLang=='en' ">
                                        <img src="../../assets/store/mogos_card_confirm_cn.png" alt="mogos-step-1" v-else-if="this.mogosLang=='cn' ">
                                        <img src="../../assets/store/mogos_card_confirm_tc.png" alt="mogos-step-1" v-else-if="this.mogosLang=='tc' ">
                                    </div>
                                </div>
                            </i-col>
                        </div>

                        <div class="Product-content">
                            <Row style="padding:0 3% 0 3%">
                                <i-col class="Product-right" :md="24" style="text-align: center">
                                    <p class="Product-name1">
                                        {{$t('mogos_details_page_advantage3')}}
                                    </p>
                                    <p class="Product-smname">{{$t('mogos_click_map')}}</p>
                                </i-col>
                                <div style="clear: both"></div>
                                <div class="Product-map-wrap">
                                    <div class="max_width Product-map">
                                        <div class="North">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area1')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content1')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/North_America_normal@2x.png" class="North_map1">
                                            <img src="../../assets/map/North_America_selected@2x.png" class="North_map2">
                                        </div>
                                        <div class="South">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area2')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content2')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/South_America_normal@2x.png" class="South_map1">
                                            <img src="../../assets/map/South_America_selected@2x.png" class="South_map2">
                                        </div>
                                        <div class="Africa">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area3')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content3')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/Africa_normal@2x.png" class="Africa_map1">
                                            <img src="../../assets/map/Africa_selected@2x.png" class="Africa_map2">
                                        </div>
                                        <div class="Asia">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area4')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content4')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/Asia_normal@2x.png" class="Asia_map1">
                                            <img src="../../assets/map/Asia_selected@2x.png" class="Asia_map2">
                                        </div>
                                        <div class="Europe">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area5')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content5')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/Europe_normal@2x.png" class="Europe_map1">
                                            <img src="../../assets/map/Europe_selected@2x.png" class="Europe_map2">
                                        </div>
                                        <div class="Oceania">
                                            <div class="Product-map-straight">
                                                <div class="Product-map-big-circle">
                                                    <div class="Product-map-font">
                                                        <p class="font-mid">{{$t('mogos_map_area6')}}</p>
                                                        <p class="font-small">{{$t('mogos_map_content6')}}</p>
                                                    </div>
                                                </div>
                                                <div class="Product-map-small-circle"></div>
                                            </div>
                                            <img src="../../assets/map/Oceania_normal@2x.png" class="Oceania_map1">
                                            <img src="../../assets/map/Oceania_selected@2x.png" class="Oceania_map2">
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </div>

                        <div class="Product-content detials_purchase" style="padding:10% 0 10% 0;">
                            <Row>
                                <i-col class="Product-right"  style="text-align: left;max-width: 1200px;margin: 0 auto">
                                    <p class="Product-name" style="color:#fff;">
                                        {{$t('mogos_details_page_advantage4')}}
                                    </p>
                                    <div class="Product-details" style="color:#fff;margin-top:30px;">
                                        <p>{{$t('mogos_details_page_advantage4_content1')}}</p>
                                        <p>{{$t('mogos_details_page_advantage4_content2')}}</p>
                                    </div>
                                    <router-link :to="{name:'Free'}" class="text-primary" v-if="free === true">
                                        <button class="Product-btn" style="color:#fff;background-color:#0084ff;">
                                            {{$t('mogos_free')}}
                                        </button>
                                    </router-link>
                                </i-col>
                            </Row>
                        </div>
                        <div class="igo-product-details-footer max_width">
                            <p style="color: #0084ff;">{{$t('shopping_notes')}}</p>
                            <p>{{$t('shopping_notes_tip')}}</p>
                        </div>

                        <div class="detail-basis max_width">
                            <guess></guess>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </Row>
</template>
<script>
    import Swiper from '../../../static/js/swiper-3.4.2.min'
    import navbar from '../Common/Navbar.vue'
    import buy from '../Common/Buy.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                value1: 0,
                lang:'',
                minus_text: 1,
                isTransparent:true,
                scroll: '',
                active: false,
                free:true,
                mogosLang:'cn',
                tabs: [
                    this.$t('mogos_details_page_advantage3_title1'),
                    this.$t('mogos_details_page_advantage3_title2'),
                    this.$t('mogos_details_page_advantage3_title3'),
                    this.$t('mogos_details_page_advantage3_title4'),
                    this.$t('mogos_details_page_advantage3_title5'),
                    this.$t('mogos_details_page_advantage3_title6')
                ],
                tabContents:[],
                num: 1,
                goods_info: {}
            }
        },
        components: {
            navbar, buy, guess
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.goods_id = this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                direction: 'vertical',
                loop: false,
                speed: 1000,
                autoplay: false,
                mousewheelReleaseOnEdges: false,
                mousewheelControl: false,
                effect: 'fade',
                fade: {
                    crossFade: true,
                },
                onTouchEnd: function () {
                    swiper.startAutoplay()
                }
            })
            $('.swiper-pagination span:nth-of-type(1)').html("<p><span>1</span>"+this.$t('mogos_step_1')+"</p>")
            $('.swiper-pagination span:nth-of-type(2)').html("<p><span>2</span>"+this.$t('ichat_step_1')+"</p>")
            $('.swiper-pagination span:nth-of-type(3)').html("<p><span>3</span>"+this.$t('ichat_step_2')+"</p>")

            //判断是否能领取mogos
            let module = 'index.php/mogos/whether'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.free = true
                }else if (parseInt(resp.data.code) === 2010){
                    this.free = false
                }
            }.bind(this))

            //语言包
            this.lang = this.$i18n.locale
            if (this.lang === 'en-US') {
                $("#slider1").removeClass("slider1")
                $("#slider1").addClass("slider1_en")
                $("#slider1").removeClass("slider1_tc")
                $("#slider2").removeClass("slider2")
                $("#slider2").addClass("slider2_en")
                $("#slider2").removeClass("slider2_tc")
                $("#slider3").removeClass("slider3")
                $("#slider3").addClass("slider3_en")
                $("#slider3").removeClass("slider3_tc")
                this.mogosLang = 'en'
            }else if(this.lang === 'zh-CN'){
                this.mogosLang = 'cn'
                $("#slider1").removeClass("slider1_en")
                $("#slider1").addClass("slider1")
                $("#slider1").removeClass("slider1_tc")
                $("#slider2").removeClass("slider2_en")
                $("#slider2").addClass("slider2")
                $("#slider2").removeClass("slider2_tc")
                $("#slider3").removeClass("slider3_en")
                $("#slider3").addClass("slider3")
                $("#slider3").removeClass("slider3_tc")
            }else{
                this.mogosLang = 'tc'
                $("#slider1").removeClass("slider1_en")
                $("#slider1").addClass("slider1_tc")
                $("#slider1").removeClass("slider1")
                $("#slider2").removeClass("slider2_en")
                $("#slider2").addClass("slider2_tc")
                $("#slider2").removeClass("slider2")
                $("#slider3").removeClass("slider3_en")
                $("#slider3").addClass("slider3_tc")
                $("#slider3").removeClass("slider3")
            }

        },
        methods: {
            addShopCart (count) {
                this.addToCart(count)
            },
            tab (index) {
                this.num = index
            },
            buyNow () {
                this.$router.push({
                    name: 'Settlement',
                    query: {
                        goods_id: this.$route.query.id,
                        number: 1
                    }
                })
            },
        }

    }
</script>
<style lang="scss">
    @import '../../assets/css/swiper-3.4.2.min.css';
    @import "../../scss/_mogos.scss";
    .mogos_main /deep/ .buy-components /deep/ .plus-minus,.mogos_main /deep/ .buy-components /deep/ .add_cart{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// mogos.vue?456e0832